module.exports = __webpack_public_path__ + "static/media/28-5.04e342c6.mp3";